import React from "react";

export default function PageTableHeaderCols({ PageName }) {
  const commonPatientHeaders = [
    { PatientID: "Patient ID", columnWidth: "w-[90px]" },
    { PatientName: "Name", columnWidth: "w-[100px]" },
    { PatientMobile: "Mobile", columnWidth: "w-[140px]" },
    { AppointmentDate: "Appt Date", columnWidth: "w-[100px]" },
    { AppointmentDay: "Appt Day", columnWidth: "w-[90px]" },
    { AppointmentTime: "Appt Time", columnWidth: "w-[80px]" },
  ];

  const dashboardHeaders = [
    ...commonPatientHeaders,
    { AppointmentDuration: "Appt Duration", columnWidth: "w-[100px]" },
    { AiSummary: "Patient Feedback", columnWidth: "w-[130px]" },
    {
      PatientStatus: "Appt Status",
    },
    {
      CallStatus: "AI Agent Call Status",
      columnWidth: "w-[140px]",
    },
  ];

  const escalationHeaders = [
    ...commonPatientHeaders,
    { AiSummary: "Patient Feedback", columnWidth: "w-[130px]" },
    { PatientStatus: "Appt Status" },
    {
      FollowUp: "Follow Up Status",
      columnWidth: "w-[140px]",
    },
    { AgentOverallStatus: "Call Details" },
  ];

  const callsHeaders = [
    { PatientID: "Patient", columnWidth: "w-[100px]" },
    { AppointmentDate: "Appt Date", columnWidth: "w-[90px]" },
    { AppointmentDay: "Appt Day", columnWidth: "w-[70px]" },
    {
      currentagentA1: "A1_DataLoader",
      columnAlign: true,
      columnWidth: "w-[80px]",
    },
    {
      currentagentA2: "A2_Calling",
      columnAlign: true,
      columnWidth: "w-[80px]",
    },
    {
      currentagentA3: "A3_VoiceMail",
      columnAlign: true,
      columnWidth: "w-[80px]",
    },
    {
      currentagentA4: "A4_Response",
      columnAlign: true,
      columnWidth: "w-[80px]",
    },
    {
      currentagentA5: "A5_Record&Transcript",
      columnAlign: true,
      columnWidth: "w-[130px]",
    },
    {
      currentagentA6: "A6_AISummary",
      columnAlign: true,
      columnWidth: "w-[80px]",
    },
    {
      currentagentA7: "A7_Escalation",
      columnAlign: true,
      columnWidth: "w-[80px]",
    },
    { currentagentA8: "A8_SMS", columnAlign: true, columnWidth: "w-[80px]" },
  ];

  const openCallsHeader = [
    ...callsHeaders,
    { AgentOverallStatus: "Call Status", columnAlign:true, columnWidth: "w-[130px]" },
  ];

  const completedCallsHeaders = [
    ...callsHeaders,
    { PatientStatus: "Appt Status", columnWidth: "w-[130px]" },
    { AgentOverallStatus: "Call Status", columnWidth: "w-[130px]" },
  ];

  const selectedComplCallHeaders = [
    { patient: "Patient" },
    { appointment: "Appointment" },
    { PatientStatus: "Appt Status" },
  ];

  const headersMap = {
    OpenCalls: openCallsHeader,
    Dashboard: dashboardHeaders,
    Escalations: escalationHeaders,
    CompletedCalls: completedCallsHeaders,
    SelCompletedCall: selectedComplCallHeaders,
  };

  return headersMap[PageName] || [];
}
